module.exports = __webpack_public_path__ + "img/CM0020_cat.f35322e4.png";